/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CourseEntity } from '../models/CourseEntity';
import type { CourseGroupEntity } from '../models/CourseGroupEntity';
import type { CustomerEntity } from '../models/CustomerEntity';
import type { GuestEntity } from '../models/GuestEntity';
import type { MultipassProductEntity } from '../models/MultipassProductEntity';
import type { PatchRebateCodeDto } from '../models/PatchRebateCodeDto';
import type { PostIssueRebateCodeDto } from '../models/PostIssueRebateCodeDto';
import type { PostRebateCodeDto } from '../models/PostRebateCodeDto';
import type { RebateCodeEntity } from '../models/RebateCodeEntity';
import type { StripePaymentProfileEntity } from '../models/StripePaymentProfileEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RebateService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Rebate Codes
     * @param archived
     * @param valid
     * @param invalid
     * @returns RebateCodeEntity Rebate Codes have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodesV1(
        archived?: boolean,
        valid?: boolean,
        invalid?: boolean,
    ): CancelablePromise<Array<RebateCodeEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code',
            query: {
                'archived': archived,
                'valid': valid,
                'invalid': invalid,
            },
        });
    }
    /**
     * Create a Rebate Code
     * @param requestBody
     * @returns RebateCodeEntity Rebate Code has been created
     * @throws ApiError
     */
    public rebateControllerCreateRebateCodeV1(
        requestBody: PostRebateCodeDto,
    ): CancelablePromise<RebateCodeEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/rebate/code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a Rebate Code
     * @param rebateCodeId
     * @param requestBody
     * @returns RebateCodeEntity Rebate Code has been updated
     * @throws ApiError
     */
    public rebateControllerUpdateRebateCodeV1(
        rebateCodeId: string,
        requestBody: PatchRebateCodeDto,
    ): CancelablePromise<RebateCodeEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/rebate/code/{rebateCodeId}',
            path: {
                'rebateCodeId': rebateCodeId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Archive a Rebate Code
     * @param rebateCodeId
     * @returns RebateCodeEntity Rebate Code has been archived
     * @throws ApiError
     */
    public rebateControllerArchiveRebateCodeV1(
        rebateCodeId: string,
    ): CancelablePromise<RebateCodeEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/rebate/code/{rebateCodeId}',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Get Rebate Code
     * @param rebateCodeId
     * @returns RebateCodeEntity Rebate Code has been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeV1(
        rebateCodeId: string,
    ): CancelablePromise<RebateCodeEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Restore a Rebate Code
     * @param rebateCodeId
     * @returns RebateCodeEntity Rebate Code has been restored
     * @throws ApiError
     */
    public rebateControllerRestoreRebateCodeV1(
        rebateCodeId: string,
    ): CancelablePromise<RebateCodeEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/rebate/code/{rebateCodeId}/restore',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Issue a Rebate Code to a Customer
     * @param rebateCodeId
     * @param requestBody
     * @returns RebateCodeEntity Rebate Code has been issued
     * @throws ApiError
     */
    public rebateControllerIssueRebateCodeV1(
        rebateCodeId: string,
        requestBody: PostIssueRebateCodeDto,
    ): CancelablePromise<RebateCodeEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/rebate/code/{rebateCodeId}/issue',
            path: {
                'rebateCodeId': rebateCodeId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Rebate Code eligible Stripe Payment Profiles
     * @param rebateCodeId
     * @returns StripePaymentProfileEntity Stripe Payment Profiles have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeEligibleStripePaymentProfilesV1(
        rebateCodeId: string,
    ): CancelablePromise<Array<StripePaymentProfileEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}/stripePaymentProfile',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Get Rebate Code eligible Courses
     * @param rebateCodeId
     * @returns CourseEntity Courses have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeEligibleCoursesV1(
        rebateCodeId: string,
    ): CancelablePromise<Array<CourseEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}/course',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Get Rebate Code eligible Course Groups
     * @param rebateCodeId
     * @returns CourseGroupEntity Course Groups have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeEligibleCourseGroupsV1(
        rebateCodeId: string,
    ): CancelablePromise<Array<CourseGroupEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}/courseGroup',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Get Rebate Code eligible Multipass Products
     * @param rebateCodeId
     * @returns MultipassProductEntity Multipass Products have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeEligibleMultipassProductsV1(
        rebateCodeId: string,
    ): CancelablePromise<Array<MultipassProductEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}/multipassProduct',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Get Customers that have been issued a Rebate Code
     * @param rebateCodeId
     * @returns CustomerEntity Customers have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeCustomersV1(
        rebateCodeId: string,
    ): CancelablePromise<Array<CustomerEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}/customer',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
    /**
     * Get Guests that have been issued a Rebate Code
     * @param rebateCodeId
     * @returns GuestEntity Guests have been returned
     * @throws ApiError
     */
    public rebateControllerGetRebateCodeGuestsV1(
        rebateCodeId: string,
    ): CancelablePromise<Array<GuestEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/rebate/code/{rebateCodeId}/guest',
            path: {
                'rebateCodeId': rebateCodeId,
            },
        });
    }
}
